<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'app',
  created () {
    if (window.localStorage.getItem('token') === 'give543jwt') {
      this.$store.commit('LOGOUT')
      this.$router.push('/login')
    }
  }
}
</script>

<style lang="less">
  @import './base';
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    box-sizing: border-box;
    height: 100%;
    text-align: center;
  }

  html,body{
    // height: 100%;
    margin: 0;
    padding: 0;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue